import { createStyles } from "@envestnet/envreact-component-library";
import type { Theme, WithStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      margin: "auto",
      alignItems: "center",
    },
    imageWrapper: {
      padding: 40,
      position: "fixed",
      left: 0,
      top: 0,
    },
    section: {
      padding: 32,
      "& > div": {
        marginTop: 0,
        maxWidth: 380,
        textAlign: "start",
        marginBottom: 32,
        display: "flex",
        flexDirection: "column",
      },
    },
    header4: {
      ...theme.fonts.h4,
      marginTop: 32,
      marginBottom: 32,
      display: "flex !important",
      flexDirection: "row",
    },
    iconWrapper: {
      marginRight: 16,
      color: theme.colors.textDefault,
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
